import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  GameStatStyled,
  GameStatText,
  GameStatNumber,
} from '../../molecules/GameStats/GameStats.styled';

const mapStateToProps = state => ({
  moveCount: state.game.moveCount,
});

const GameStat = ({ moveCount }) => (
  <GameStatStyled>
    <GameStatText>Moves</GameStatText>
    <GameStatNumber>{moveCount}</GameStatNumber>
  </GameStatStyled>
);

export default connect(mapStateToProps)(GameStat);

GameStat.propTypes = {
  moveCount: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/atoms/MoveCount/MoveCount.js